import { type ChangeEvent, useCallback, useState } from "react";

export function useInputState(initialValue: string = "") {
  const [value, setValue] = useState(initialValue);
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value), []);
  return [value, onChange] as [string, (e: ChangeEvent<HTMLInputElement>) => void];
}
